/**
 * Enum containing all dynamic value calculation parameters for zoom-based scaling
 * Each property defines the min and max values for linear interpolation based on zoom level
 */
export enum DynamicValuesEnum {
  // Zoom level bounds
  MIN_ZOOM = 1,
  MAX_ZOOM = 10,

  // Circle/Asset parameters
  CIRCLE = 12,

  // Label text parameters
  FONT_SIZE = 12,

  // Label container parameters
  LABEL_HEIGHT = 22,
  LABEL_Y_OFFSET = 22,
  LABEL_PADDING = 10,

  // Label styling parameters
  TEXT_PADDING = 6,
  STROKE_WIDTH = 1,
  CORNER_RADIUS = 4,

  // Shadow parameters
  SHADOW_BLUR = 3,
  SHADOW_COLOR = 0.15,
  SHADOW_OFFSET = 1,

  // The photocell and gateway sizes should be the same; otherwise, create a separate Konva Image.
  // Gateway parameters
  GATEWAY_SIZE = 23,
  GATEWAY_LABEL_OFFSET = 10,

  // PhotoCell parameters
  PHOTOCELL_SIZE = 23,
  PHOTOCELL_LABEL_OFFSET = 6,

}